import * as React from "react";
import { UitkIcon } from "uitk-react-icons";
import { InfoDialog } from "../../MerchCampaign/components/InfoDialog";
import { Layer, Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";

export const Information = () => {
  const [showDialog, setShowDialog] = React.useState(false);

  const handleDialog = () => {
    setShowDialog(previousValue => !previousValue);
  };
  const { formatText } = useLocalization();

  return (
    <>
      <div onClick={handleDialog} data-testid="info-icon">
        <UitkIcon name="info_outline" />
      </div>

      {showDialog && (
        <Viewport>
          <ViewSmall>
            <Layer id="more-info-multiple-places-dialog">
              <InfoDialog
                infoText={formatText(locKeys.dialogText)}
                buttonText={formatText(locKeys.dialogButton)}
                closeDialog={handleDialog}
              />
            </Layer>
          </ViewSmall>
          <ViewLarge>
            <div className="uitk-type-paragraph-300 l-l-padding-two xl-l-padding-two">
              <p>{formatText(locKeys.dialogText)}</p>
            </div>
          </ViewLarge>
        </Viewport>
      )}
    </>
  );
};
